module.exports = __webpack_public_path__ + "images/fd1e72314b1ed7b17a065407a55ae2d6.png";